/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import { IconButton, Paper, TextField, Typography, Button, Tooltip, Checkbox } from '@material-ui/core'
import { StopRounded } from '@material-ui/icons'
import EditIcon from '@material-ui/icons/Edit'
import AddIcon from '@material-ui/icons/Add'
import { clustersNames, currentDate } from '@auteco/constants'
import { useStyles } from './styles'
import { DialogAgreement } from '../DialogAgreement'
import { DialogAddNote } from '../DialogAddNote'
import { ListHistoryNotes } from '../ListHistoryNotes'

const CardInfo = ({ index, item, type, isEnabled, onDragStart, onDragOver, onDrop, putDetailedPlan, handleAddCardPDF }) => {
    const [edit, setEdit] = useState(false)
    const [info, setInfo] = useState({})
    const [dialogInfo, setDialogInfo] = useState({ addNote: false, history: false, finalice: false, item: {}, isEnabled: false })
    // const [error, setError] = useState(false)

    const classes = useStyles()
    const color = type !== 'roadMapList' ? 'primary' : 'orange';


    const updateInfo = ({ param, value }) => {
        setInfo({ ...info, [param]: value })
    }

    const handleEdit = () => {
        if (edit) {
            setInfo({ ...info, date: item?.finalizacion })
            // setError(false)
            setEdit(false)
        } else {
            setEdit(true)
        }
    }
    const sendDetailedPlan = ({ valoracion_final, finalizado, fecha_cierre }) => {
        const newInfo = { ...info, valoracion_final, finalizado, fecha_cierre }
        setInfo(newInfo)
        putDetailedPlan({ item: newInfo })
        setEdit(false)
        // setError(false)
    }

    const handleOpenDialog = ({ name }) => {
        setDialogInfo({ ...dialogInfo, [name]: true, item, isEnabled })
    }

    const handleCloseDialog = ({ name }) => {
        setDialogInfo({ ...dialogInfo, [name]: false, item: {}, isEnabled: false })
    }

    const findName = ({ id }) => clustersNames.find(cluster => cluster.id === id).name

    useEffect(() => {
        const newItemObj = { ...item }
        setInfo(newItemObj)
    }, [item])

    return (
        <>
            <DialogAgreement open={dialogInfo.finalice} onClose={() => handleCloseDialog({ name: 'finalice' })} sendDetailedPlan={sendDetailedPlan} />
            <ListHistoryNotes open={dialogInfo.history} onClose={() => handleCloseDialog({ name: 'history' })} id={dialogInfo.item.id} isEnabled={dialogInfo.isEnabled} />
            <DialogAddNote open={dialogInfo.addNote} onClose={() => handleCloseDialog({ name: 'addNote' })} item={dialogInfo.item} />
            <Paper
                className={classes.container}
                draggable="true"
                onDragStart={(event) => onDragStart(event, item, type, index)}
                onDragOver={onDragOver}
                onDrop={(event) => onDrop(event, type, index)}
                elevation={4}
            >
                <div className={classes.header}>
                    <StopRounded color={color} style={{ color: `${color}` }} />
                    <Typography className={classes.title}>{item.titulo}</Typography>
                    {type !== 'roadMapList' &&
                        <div className={classes.iconsContainer}>
                            <IconButton
                                disabled={!isEnabled}
                                onClick={handleEdit}
                            >
                                <EditIcon />
                            </IconButton>
                            <Tooltip title='Generar PDF'>
                                <Checkbox
                                    color='primary'
                                    onChange={(e) => handleAddCardPDF({ event: e, card: item })} />
                            </Tooltip>
                        </div>

                    }
                </div>
                <Typography className={classes.subtitle}><b>Descripción:</b> {info?.texto}</Typography>
                <Typography className={classes.subtitle}><b>Prioridad:</b> {info?.prioridad}</Typography>
                {type === 'roadMapList' && <Typography className={classes.subtitle}><b>Beneficio:</b> {info?.valoracion}</Typography>}
                {type === 'roadMapList' && <Typography className={classes.subtitle}><b>Inversión:</b>{info?.costo}</Typography>}
                {type === 'roadMapList' && <Typography className={classes.subtitle}><b>Tiempo estimado retorno de la inversión:</b> {info?.finalizacion}</Typography>}
                <Typography className={classes.subtitle}><b>Cluster:</b> {findName({ id: item?.cluster_id })}</Typography>
                {type !== 'roadMapList' &&
                    <div className={classes.additionalInfoContainer}>
                        <div className={classes.textFieldContainer}>
                            <Typography className={classes.subtitle}><b>Beneficio</b></Typography>
                            <TextField
                                value={info?.valoracion || ''}
                                disabled={!edit}
                                className={classes.textField}
                                type='number'
                                onChange={(e) => updateInfo({ param: 'valoracion', value: e.target.value })}
                            />
                        </div>
                        <div className={classes.textFieldContainer}>
                            <Typography className={classes.subtitle}><b>Inversión</b></Typography>
                            <TextField
                                type='number'
                                disabled={!edit}
                                value={info?.costo || ''}
                                className={classes.textField}
                                onChange={(e) => updateInfo({ param: 'costo', value: e.target.value })}
                            />
                        </div>
                        <div className={`${classes.textFieldContainer} ${classes.textFieldContainerLast}`}>
                            <Typography className={classes.subtitle} ><b>Tiempo estimado retorno de la inversión:</b></Typography>
                            <TextField
                                type='date'
                                disabled={!edit}
                                value={info?.finalizacion || ''}
                                className={classes.textField}
                                InputProps={{
                                    inputProps: { min: currentDate }
                                }}
                                onChange={(e) => updateInfo({ param: 'finalizacion', value: e.target.value })}
                            />
                        </div>
                        {edit &&
                            <Button
                                color='primary'
                                variant='contained'
                                className={classes.sendButton}
                                onClick={() => sendDetailedPlan({ valoracion_final: 0, finalizado: 0, fecha_cierre: '' })}
                            >
                                Actualizar
                            </Button>
                        }
                    </div>
                }
                {(type !== 'roadMapList' && !edit) &&
                    <div className={classes.historyContainer}>
                        <Tooltip title='Añadir nota'>
                            <IconButton
                                className={classes.btnHistory}
                                disabled={!isEnabled}
                                onClick={() => handleOpenDialog({ name: 'addNote' })}
                            >
                                <AddIcon color='primary' />
                            </IconButton>
                        </Tooltip>
                        <Button
                            variant='contained'
                            color='primary'
                            onClick={() => handleOpenDialog({ name: 'history' })}
                        >
                            Histórico
                        </Button>
                        <Button
                            variant='contained'
                            className={classes.btnFinalizaded}
                            disabled={!isEnabled}
                            onClick={() => handleOpenDialog({ name: 'finalice' })}
                        >
                            Finalizar
                        </Button>
                    </div>
                }
            </Paper>
        </>
    )
}

export { CardInfo }